import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { PORTFOLIO_QUERY_KEYS } from "@/components/modules/portfolio/api/queries/usePortfolio";
import { getPortfolioByIdAction } from "@/components/modules/portfolio/api/actions/actions";
import { getAdminPortfolioByIdAction } from "@/components/modules/admin/api/actions/portfolios.actions";

/**
 * Fetches the selected property's detail (owner or, in backoffice, the viewed
 * user's) so the associate flow can read its computed location name — a value
 * the portfolios list doesn't carry.
 */
export function useSelectedPropertyDetail(portfolioId, isBackofficeView) {
  const $ = _c(9);
  let t0;
  if ($[0] !== portfolioId) {
    t0 = PORTFOLIO_QUERY_KEYS.getPortfolio(portfolioId);
    $[0] = portfolioId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isBackofficeView || $[3] !== portfolioId) {
    t1 = () => isBackofficeView ? getAdminPortfolioByIdAction({
      portfolioId
    }) : getPortfolioByIdAction(portfolioId);
    $[2] = isBackofficeView;
    $[3] = portfolioId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!portfolioId;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
}